import { render, staticRenderFns } from "./210309.vue?vue&type=template&id=38fa13b4&scoped=true"
import script from "./210309.vue?vue&type=script&lang=js"
export * from "./210309.vue?vue&type=script&lang=js"
import style0 from "./210309.vue?vue&type=style&index=0&id=38fa13b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fa13b4",
  null
  
)

export default component.exports